import React from "react";
import Element from "../Element"; // We now use Element directly
import { Card } from "@material-ui/core";
import PropTypes from "prop-types";
import ClearIcon from "@material-ui/icons/Clear";
import "./MultiGroup.css";
import _ from "lodash";

const MultiGroup = (props) => {
    const handleNew = () => {
        const currentValue = Array.isArray(props.value) ? props.value : [];
        props.onChange([...currentValue, {}], props.name);
    };

    const handleDelete = (idx) => {
        const newVal = props.value.filter((obj, index) => idx !== index);
        props.onChange(newVal, props.name);
    };

    // This handler receives the index of the item being changed.
    const handleItemChange = (idx, fieldValue, fieldName) => {
        const currentArray = Array.isArray(props.value) ? props.value : [];
        const updatedArray = [...currentArray]; // Create a mutable copy

        // Ensure the item exists before trying to set a property on it
        if (!updatedArray[idx]) {
            updatedArray[idx] = {};
        }

        // Use lodash.set to safely update nested properties (like 'Domicilio.Calle')
        updatedArray[idx] = _.set(updatedArray[idx], fieldName, fieldValue);

        // Pass the entire updated array up to the main form state
        props.onChange(updatedArray, props.name);
    };

    const valueAsArray = Array.isArray(props.value) ? props.value : [];

    return (
        <div className="w-full">
            {valueAsArray.map((item, idx) => (
                <div key={item._id || `multigroup-item-${idx}`} className="multigroup-item-container">
                    <Card variant="outlined" className="card-item">
                        <div style={{ padding: "20px" }}>
                            {props.title && <h4 className="text-lg font-bold mb-4">{`${props.title} ${idx + 1}`}</h4>}
                            
                            {/* Iterate over the fields for each item in the array */}
                            {(props.fields || []).map(field => {
															const dynamicOptions = typeof field.options === 'function'
                                    ? field.options(item) // If options is a function, call it with the current item data
                                    : field.options;
														
                                return <div key={field.name} style={{ marginBottom: '1rem' }}>
                                    <Element
                                        element={{ ...field, options: dynamicOptions }}
                                        value={_.get(item, field.name)}
                                        // The onChange now passes the index AND the field name/value
                                        onChange={(val, name) => handleItemChange(idx, val, name)}
                                        onFile={props.onFile}
                                        removeFile={props.removeFile}
                                        files={props.files}
                                    />
                                </div>
														})}
                        </div>
                    </Card>
                    <div className="multigroup-delete-icon">
                        <ClearIcon onClick={() => handleDelete(idx)} fontSize="small" style={{ color: "red", cursor: 'pointer' }} />
                    </div>
                </div>
            ))}
            <div style={{ textAlign: "right", marginTop: '10px' }}>
                <button type="button" className="rounded-3xl text-white bg-orange py-2 px-5" onClick={handleNew}>
                    {props.labelAddButton || "Agregar"}
                </button>
            </div>
        </div>
    );
};

MultiGroup.propTypes = {
    onChange: PropTypes.func.isRequired,
    onFile: PropTypes.func,
    removeFile: PropTypes.func,
    files: PropTypes.any,
    value: PropTypes.array,
    name: PropTypes.string.isRequired,
    fields: PropTypes.array.isRequired, // 'fields' is the correct prop name for defining the structure
    labelAddButton: PropTypes.string,
    title: PropTypes.string,
};
export default MultiGroup
// Add a corresponding CSS file for better styling
// /src/components/FormComponents/MultiGroup/MultiGroup.css
/*
.multigroup-item-container {
    display: flex;
    align-items: flex-start;
    margin-bottom: 15px;
    position: relative;
}

.card-item {
    flex-grow: 1;
}

.multigroup-delete-icon {
    padding-top: 20px;
    padding-left: 10px;
}
*/